/**
 * @generated SignedSource<<2c923765e00c991e4d65d25196f913d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VideoElementForm_VimeoSourceQuery$variables = Record<PropertyKey, never>;
export type VideoElementForm_VimeoSourceQuery$data = {
  readonly Admin: {
    readonly VimeoVideoSource: {
      readonly GetDefaultVimeoVideoSource: {
        readonly id: string;
      } | null | undefined;
    };
  };
};
export type VideoElementForm_VimeoSourceQuery = {
  response: VideoElementForm_VimeoSourceQuery$data;
  variables: VideoElementForm_VimeoSourceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminQueryType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VimeoVideoSourceAdminSchema",
        "kind": "LinkedField",
        "name": "VimeoVideoSource",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vimeo_VimeoVideoSource",
            "kind": "LinkedField",
            "name": "GetDefaultVimeoVideoSource",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoElementForm_VimeoSourceQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "VideoElementForm_VimeoSourceQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0fbef4320d520e182ed6b205c0f0ee7e",
    "id": null,
    "metadata": {},
    "name": "VideoElementForm_VimeoSourceQuery",
    "operationKind": "query",
    "text": "query VideoElementForm_VimeoSourceQuery {\n  Admin {\n    VimeoVideoSource {\n      GetDefaultVimeoVideoSource {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cbe1eb35074abd33cfd8d8f607185c8f";

export default node;
